import React from 'react';
import ContactForm from './ContactForm';

// Farm pin from the 'Mubarak Farm UG' Google Business Profile.
const FARM_LAT = 0.8403414;
const FARM_LON = 32.4977066;
const FARM_MAP_URL = 'https://maps.google.com/maps?cid=7459800105914995170';
const FARM_MAP_EMBED_URL = `https://www.openstreetmap.org/export/embed.html?bbox=${FARM_LON - 0.018},${FARM_LAT - 0.012},${FARM_LON + 0.018},${FARM_LAT + 0.012}&layer=mapnik&marker=${FARM_LAT},${FARM_LON}`;

const labelClass = 'text-xs font-semibold uppercase tracking-[0.2em] text-clay mb-2';
const valueLinkClass = 'font-heading text-xl text-gray-900 hover:text-clay transition-colors';

// Contact details, farm map, and message form. Shared by the home page contact
// section and the /contact page. `formHeading` sets the form title's heading level
// so it follows the outline of the page that renders it.
export default function ContactBlock({ formHeading: FormHeading = 'h3' }) {
  return (
    // Source order is details, form, map, so the form comes before the map on small
    // screens. On large screens the form spans both rows of the right column.
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-x-16 lg:gap-y-8 lg:items-start">
      <dl className="lg:col-span-5 divide-y divide-gray-300/70 border-y border-gray-300/70">
        <div className="py-6">
          <dt className={labelClass}>Email</dt>
          <dd>
            <a href="mailto:mubarakfarm53@gmail.com" className={`${valueLinkClass} [overflow-wrap:anywhere]`}>mubarakfarm53@gmail.com</a>
            <p className="text-sm text-gray-600 mt-2">Reply within 24 hours.</p>
          </dd>
        </div>

        <div className="py-6">
          <dt className={labelClass}>WhatsApp, Pakistan desk</dt>
          <dd>
            <a href="https://wa.me/447716089293" target="_blank" rel="noopener noreferrer" className={valueLinkClass}>+44 7716 089293</a>
            <p className="text-sm text-gray-600 mt-2">Wholesale orders, samples, and pricing.</p>
          </dd>
        </div>

        <div className="py-6">
          <dt className={labelClass}>Call / WhatsApp, Uganda</dt>
          <dd>
            <a href="https://wa.me/256707776564" target="_blank" rel="noopener noreferrer" className={valueLinkClass}>+256 707 776 564</a>
            <p className="text-sm text-gray-600 mt-2">Mon-Fri, 8am-5pm EAT.</p>
          </dd>
        </div>

        <div className="py-6">
          <dt className={labelClass}>Visit</dt>
          <dd>
            <p className="font-heading text-xl text-gray-900 leading-tight">Luweero, Nabinaka Rd</p>
            <p className="text-sm text-gray-600 mt-2">Nabutaka, Uganda. Tours by appointment.</p>
            <a href={FARM_MAP_URL} target="_blank" rel="noopener noreferrer" className="mt-2 inline-block text-sm font-medium text-clay hover:text-clay/80 transition-colors">
              Get directions <span aria-hidden="true">&rarr;</span>
            </a>
          </dd>
        </div>
      </dl>

      <div className="lg:col-span-7 lg:col-start-6 lg:row-start-1 bg-white rounded-3xl border border-gray-200 p-6 sm:p-8 lg:p-10">
        <FormHeading className="font-heading text-2xl sm:text-3xl text-gray-900 mb-2">Send us a message</FormHeading>
        <p className="text-gray-600 mb-8">For wholesale enquiries, include the grade and quantity you need.</p>
        <ContactForm />
      </div>

      <figure className="lg:col-span-12">
        <iframe
          className="w-full aspect-square sm:aspect-[4/3] lg:aspect-[21/8] rounded-3xl border border-gray-200 bg-gray-100"
          src={FARM_MAP_EMBED_URL}
          title="Map of Mubarak Farm in Nabutaka, Luweero District, Uganda"
          loading="lazy"
        />
        <figcaption className="mt-3 text-sm text-gray-600 italic">Mubarak Farm, Nabutaka, Luweero District.</figcaption>
      </figure>
    </div>
  );
}
